import React from 'react'
import './WhatWeOffer.scss'
import Target from '../Assets/Images/target.webp'
import Arrow from '../Assets/Images/arrow.webp'
import Scale from '../Assets/Images/scale.webp'
import Indicator from '../Assets/Images/indicator.webp'
import MoneyBag from '../Assets/Images/moneybag.webp'
import TwoMoneyBags from '../Assets/Images/2moneybags.webp'
import { useInView } from 'react-intersection-observer'
import { useLanguage } from '../Contexts/LanguageContext'

const WhatWeOffer = () => {
    const { ref: ref1, inView: v1 } = useInView({ threshold: 1, triggerOnce: false });
    const { ref: ref2, inView: v2 } = useInView({ threshold: 1, triggerOnce: false });
    const { ref: ref3, inView: v3 } = useInView({ threshold: 1, triggerOnce: false });
    const { language } = useLanguage();

    return (
        <div className='what-we-offer' id='co-oferujemy'>
            <h2>{language === 'polish' ? 'Co oferujemy' : 'What we offer'}</h2>
            <div className='offer-content'>
                <div className='offer offer-one'>
                    <div ref={ref1} className={`animation animation-one ${v1 ? 'active-anim-1' : ''}`}>
                        <img src={Target} alt='Tarcza strzelnicza' className='img01'/>
                        <img src={Arrow} alt='Strzała' className='img02'/>
                    </div>
                    <h3>{language === 'polish' ? 'Precyzyjne targetowanie' : 'Precise targeting'}</h3>
                    <p>{language === 'polish' ? 'wybieraj kraj, język, urządzenie i tematykę kanału lub mini appsa.' : 'choose country, language, device and topic of the channel or mini app.'}</p>
                </div>
                <div className='offer offer-two'>
                    <div ref={ref2} className={`animation animation-two ${v2 ? 'active-anim-2' : ''}`}>
                        <img src={Scale} alt='Waga' className='img01'/>
                        <img src={Indicator} alt='Wskazówka' className='img02' />
                    </div>
                    <h3>{language === 'polish' ? 'Wydajność i transparentność' : 'Performance and transparency'}</h3>
                    <p>{language === 'polish' ? 'śledź kliknięcia, rejestracje i zakupy w czasie rzeczywistym.' : 'track clicks, registrations, and purchases in real-time.'}</p>
                </div>
                <div className='offer offer-three'>
                    <div ref={ref3} className={`animation animation-three ${v3 ? 'active-anim-3' : ''}`}>
                        <img src={MoneyBag} alt='Worek z pieniędzmi' className='img01'/>
                        <img src={TwoMoneyBags} alt='Dwa worki z pieniędzmi' className='img02'/>
                    </div>
                    <h3>{language === 'polish' ? 'Monetyzacja dla wydawców' : 'Monetization for publishers'}</h3>
                    <p>{language === 'polish' ? 'zarabiaj przez CPM, CPC, CPA lub publikacje sponsorowane.' : 'earn through CPM, CPC, CPA, or sponsored posts.'}</p>
                </div>
            </div>
        </div>
    )
}

export default WhatWeOffer